module.exports = __webpack_public_path__ + "img/hagrids_hut_on_fire.7ee3504c.jpg";